// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: atdcK1hSZxqWg32TQQ3iWK
// Component: PGN87NpT68
import * as React from "react";
import {
  PlasmicImg as PlasmicImg__,
  Stack as Stack__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  hasVariant,
  useCurrentUser,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { useScreenVariants as useScreenVariantscmLbcqStcJj } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: CMLbcqStcJJ/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic_blank_website_mobile_first.module.css"; // plasmic-import: atdcK1hSZxqWg32TQQ3iWK/projectcss
import sty from "./PlasmicPHeader.module.css"; // plasmic-import: PGN87NpT68/css
import Icon2Icon from "./icons/PlasmicIcon__Icon2"; // plasmic-import: 7lJmqVTmVW/icon
import image3Ow91FGgx from "./images/image3.png"; // plasmic-import: OW91-FGgx/picture
import image2ZncdvHa7K from "./images/image2.png"; // plasmic-import: ZncdvHa7K/picture

createPlasmicElementProxy;

export const PlasmicPHeader__VariantProps = new Array("justLogo");

export const PlasmicPHeader__ArgProps = new Array("links");

const $$ = {};

function PlasmicPHeader__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {
          links: []
        },
        props.args
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = useCurrentUser?.() || {};
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "justLogo",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.justLogo
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantscmLbcqStcJj()
  });
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        sty.root,
        { [sty.rootjustLogo]: hasVariant($state, "justLogo", "justLogo") }
      )}
    >
      <div
        className={classNames(projectcss.all, sty.freeBox__cKQnk, {
          [sty.freeBoxjustLogo__cKQnkyyLvL]: hasVariant(
            $state,
            "justLogo",
            "justLogo"
          )
        })}
      >
        <div
          data-plasmic-name={"reload"}
          data-plasmic-override={overrides.reload}
          className={classNames(projectcss.all, sty.reload, {
            [sty.reloadjustLogo]: hasVariant($state, "justLogo", "justLogo")
          })}
        >
          <PlasmicImg__
            alt={""}
            className={classNames(sty.img__htbed, {
              [sty.imgjustLogo__htbedyyLvL]: hasVariant(
                $state,
                "justLogo",
                "justLogo"
              )
            })}
            displayHeight={"60px"}
            displayMaxHeight={"none"}
            displayMaxWidth={"100%"}
            displayMinHeight={"0"}
            displayMinWidth={"0"}
            displayWidth={"60px"}
            loading={"lazy"}
            src={{
              src: image3Ow91FGgx,
              fullWidth: 960,
              fullHeight: 960,
              aspectRatio: undefined
            }}
          />
        </div>
      </div>
      <Stack__
        as={"div"}
        hasGap={true}
        className={classNames(projectcss.all, sty.freeBox__tIxl6, {
          [sty.freeBoxjustLogo__tIxl6YyLvL]: hasVariant(
            $state,
            "justLogo",
            "justLogo"
          )
        })}
      >
        {(_par => (!_par ? [] : Array.isArray(_par) ? _par : [_par]))(
          (() => {
            try {
              return $props.links;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return [];
              }
              throw e;
            }
          })()
        ).map((__plasmic_item_0, __plasmic_idx_0) => {
          const currentItem = __plasmic_item_0;
          const currentIndex = __plasmic_idx_0;
          return (
            <a
              data-plasmic-name={"link"}
              data-plasmic-override={overrides.link}
              className={classNames(
                projectcss.all,
                projectcss.a,
                projectcss.__wab_text,
                sty.link
              )}
              key={currentIndex}
              onClick={async event => {
                const $steps = {};
                $steps["runCode"] = true
                  ? (() => {
                      const actionArgs = {
                        customFunction: async () => {
                          return currentItem.onClick && currentItem.onClick();
                        }
                      };
                      return (({ customFunction }) => {
                        return customFunction();
                      })?.apply(null, [actionArgs]);
                    })()
                  : undefined;
                if (
                  $steps["runCode"] != null &&
                  typeof $steps["runCode"] === "object" &&
                  typeof $steps["runCode"].then === "function"
                ) {
                  $steps["runCode"] = await $steps["runCode"];
                }
              }}
            >
              <React.Fragment>
                {(() => {
                  try {
                    return currentItem.label;
                  } catch (e) {
                    if (
                      e instanceof TypeError ||
                      e?.plasmicType === "PlasmicUndefinedDataError"
                    ) {
                      return "....";
                    }
                    throw e;
                  }
                })()}
              </React.Fragment>
            </a>
          );
        })}
      </Stack__>
      <div
        data-plasmic-name={"logo"}
        data-plasmic-override={overrides.logo}
        className={classNames(projectcss.all, sty.logo, {
          [sty.logojustLogo]: hasVariant($state, "justLogo", "justLogo")
        })}
      >
        <PlasmicImg__
          alt={""}
          className={classNames(sty.img__t3UjT, {
            [sty.imgjustLogo__t3UjTyyLvL]: hasVariant(
              $state,
              "justLogo",
              "justLogo"
            )
          })}
          displayHeight={
            hasVariant(globalVariants, "screen", "desktopOnly")
              ? "180px"
              : "99px"
          }
          displayMaxHeight={"none"}
          displayMaxWidth={"100%"}
          displayMinHeight={"0"}
          displayMinWidth={"0"}
          displayWidth={"140px"}
          loading={"lazy"}
          src={{
            src: image2ZncdvHa7K,
            fullWidth: 1600,
            fullHeight: 1600,
            aspectRatio: undefined
          }}
        />

        {(
          hasVariant($state, "justLogo", "justLogo") &&
          hasVariant(globalVariants, "screen", "desktopOnly")
            ? true
            : hasVariant(globalVariants, "screen", "desktopOnly")
            ? true
            : false
        ) ? (
          <div
            data-plasmic-name={"text"}
            data-plasmic-override={overrides.text}
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text,
              { [sty.textjustLogo]: hasVariant($state, "justLogo", "justLogo") }
            )}
          >
            {"SGS Pelioikeudet"}
          </div>
        ) : null}
      </div>
      <div
        data-plasmic-name={"menuWrapper"}
        data-plasmic-override={overrides.menuWrapper}
        className={classNames(projectcss.all, sty.menuWrapper, {
          [sty.menuWrapperjustLogo]: hasVariant($state, "justLogo", "justLogo")
        })}
      >
        <div className={classNames(projectcss.all, sty.freeBox___3BShE)}>
          <Icon2Icon
            data-plasmic-name={"menuIcon"}
            data-plasmic-override={overrides.menuIcon}
            className={classNames(projectcss.all, sty.menuIcon, {
              [sty.menuIconjustLogo]: hasVariant($state, "justLogo", "justLogo")
            })}
            role={"img"}
          />

          <div
            data-plasmic-name={"menu"}
            data-plasmic-override={overrides.menu}
            className={classNames(projectcss.all, sty.menu)}
          />
        </div>
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "reload",
    "link",
    "logo",
    "text",
    "menuWrapper",
    "menuIcon",
    "menu"
  ],

  reload: ["reload"],
  link: ["link"],
  logo: ["logo", "text"],
  text: ["text"],
  menuWrapper: ["menuWrapper", "menuIcon", "menu"],
  menuIcon: ["menuIcon"],
  menu: ["menu"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicPHeader__ArgProps,
          internalVariantPropNames: PlasmicPHeader__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicPHeader__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicPHeader";
  } else {
    func.displayName = `PlasmicPHeader.${nodeName}`;
  }
  return func;
}

export const PlasmicPHeader = Object.assign(
  // Top-level PlasmicPHeader renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    reload: makeNodeComponent("reload"),
    link: makeNodeComponent("link"),
    logo: makeNodeComponent("logo"),
    text: makeNodeComponent("text"),
    menuWrapper: makeNodeComponent("menuWrapper"),
    menuIcon: makeNodeComponent("menuIcon"),
    menu: makeNodeComponent("menu"),
    // Metadata about props expected for PlasmicPHeader
    internalVariantProps: PlasmicPHeader__VariantProps,
    internalArgProps: PlasmicPHeader__ArgProps
  }
);

export default PlasmicPHeader;
/* prettier-ignore-end */
